<template>
  <el-menu class="left-nav" :style="{width: leftWidth + 'px'}" :collapse="isCollapse" @select="menuSelect"
    :default-active="$route.path" unique-opened background-color="#ECF7FF" text-color="#333333"
    active-text-color="#fffff">
    <el-menu-item index="title-index" class="title-item" disabled>
      <template #title>
        <div class="title-item-div">
          <div class="logo-box">
            <img :src="logoH" alt="">
          </div>
          <div class="title-box">先行道桥员工服务平台</div>
        </div>
      </template>
    </el-menu-item>

    <template v-for="menu in menus" :key="menu.id">
      <el-sub-menu :index="menu.path" v-if="menu.children && menu.children.length">
        <template #title>
          <el-icon v-if="menu.icon" style="color: blue;"><component :is="menu.icon" /></el-icon>
          <span>{{menu.name}}</span>
        </template>
        <template v-for="subMenu in menu.children" :key="subMenu.id">
          <el-menu-item :index="subMenu.path"><el-icon v-if="subMenu.icon" style="color: blue;"><component :is="subMenu.icon" /></el-icon>{{subMenu.name}}</el-menu-item>
        </template>
      </el-sub-menu>
      <el-menu-item :index="menu.path" v-else>
        <el-icon v-if="menu.icon" style="color: blue;"><component :is="menu.icon" /></el-icon>
        <span>{{menu.name}}</span>
      </el-menu-item>
    </template>
  </el-menu>
</template>
<script>
import { defineComponent } from "vue";
import { mapGetters } from 'vuex';
import logoH from '@/assets/logoH.svg';
export default defineComponent({
  props: {
    isCollapse: Boolean,
    leftWidth: Number
  },
  data() {
    return {
      logoH
    }
  },
  computed: {    
    ...mapGetters(['menus'])
  },
  methods: {
    menuSelect(index, indexPath) {
      if (index === 'title-index') {
        return;
      }
      this.$router.push(index);
    }
  }
});
</script>

<style lang="scss" scoped>
.el-menu.left-nav {
  height: 100%;
  overflow-y: auto;
  .el-menu-item.title-item {
    background-color: #ECF7FF;
    color: #333333 !important;
    opacity: 1;
    cursor: default;
    font-weight: bold;
    font-size: 1.1em;
    height: 120px;
    text-align: center;
    .title-item-div {
      width: 100%;
      .logo-box img {
        height: 50px;
      }
      .title-box {
        font-weight: bold;
      }
    }
  }
  .el-menu-item.is-active:not(.title-item),
  .el-menu-item:not(.title-item):hover {
    background-color: #CEEAFF;
  }
}
</style>